class ManualTree {

    _root = [];
    _manuals = [];
    _manualNodes = [];


    constructor(manuals = []) {
        this.setManuals(manuals);
    }

    setManuals(manuals) {
        this._manuals = manuals;
        this.treenize();
        this.printTree();
        this.arrangement();
        this.printArray();
    }

    size() {
        return this._root.length;
    }

    get items() {
        return this._root;
    }

    get nodes() {
        return this._manualNodes;
    }

    // 트리 구조의 노드를 배열로 변환합니다.
    arrangement() {
        this._root.forEach(rootNode => {
            this.insertNodeAsArray(rootNode);
        });
    }

    insertNodeAsArray(manualNode) {
        this._manualNodes.push(manualNode);

        if (!manualNode.children || manualNode.children.length === 0) return;

        manualNode.children.forEach(child => {
            this.insertNodeAsArray(child);
        });
    }

    treenize() {
        this._manuals.forEach(manual => {
            // 생성할 아이템이 트리상에 이미 존재하는지 여부를 검사합니다.
            const node = this.findNodeById(manual.id);
            if (!!node) return; // 이미 존재합니다. 다음진행.
            this.insertNode(new ManualNode(manual));
        });
    }

    findManual(id) {
        return this._manuals.find(manual => manual.id === id);
    }

    findNodeByCanonicalName(canonicalName, nodes) {
        const target = nodes || this._root;
        for (let i = 0; i < target.length; i++) {
            const node = target[i];
            if (node.canonicalName === canonicalName) return node;
            if (node.hasChildrenNode()) {
                const found = this.findNodeByCanonicalName(canonicalName, node.children); // ------------------- 리커시브 호출입니다. 주의하세요.
                if (!!found) return found;
            }
        }
        return null;
    }

    findNodeById(id, nodes) {
        const target = nodes || this._root;
        for (let i = 0; i < target.length; i++) {
            const node = target[i];
            if (node.id === id) return node;
            if (node.hasChildrenNode()) {
                const found = this.findNodeById(id, node.children); // ------------------- 리커시브 호출입니다. 주의하세요.
                if (!!found) return found;
            }
        }
        return null;
    }

    insertNode(manualNode) {
        // 부모가 없습니다. 최상위 노드로 추가합니다.
        if (manualNode.isRootNode()) {
            this.insertNodeAsRoot(manualNode);
        } else {
            this.insertNodeAsChild(manualNode);
        }
    }

    insertNodeAsRoot(node) {
        this._root.push(node);
    }

    insertNodeAsChild(node) {
        // 부모 노드에 추가하기 위해 부모 노드를 찾습니다.
        const pid = node.parentId;
        const parentNode = this.findNodeById(pid);
        // 부모 노드가 존재합니다. 부모의 자식으로 추가합니다.
        if (!!parentNode) {
            parentNode.addChildNode(node);
        }
        // 부모 노드가 없습니다. 부모를 생성해서 삽입 후 추가합니다.
        else {
            // 부모 노르로 만들 부모 퍼미션을 찾습니다.
            const manual = this.findManual(pid);
            if (!!manual) {
                this.insertNode(new ManualNode(manual)); // ------------------- 리커시브 호출입니다. 주의하세요.
                this.insertNode(node); // ------------------- 리커시브 호출입니다. 주의하세요.
            } else {
                // 최상위 노드입니다. 아무것도 하지 않습니다.
            }
        }
    }

    printTree() {
        this._root.forEach(node => {
            this.printNode(node, 1);
        });
    }

    printArray() {
        console.log("==================== printArray ====================");
        this.nodes.forEach(node => {
            this.printNode(node, 1);
        });
    }

    printNode(node, depth) {
        let prefix = '';
        for (let i = 0; i < depth; i++) {
            prefix += '   ';
        }
        console.log(depth + ' - ' + prefix + ':' + node.name + '(' + node.id + ') - ' + node.canonicalName);
        if (node.hasChildrenNode()) {
            node.children.forEach(child => {
                this.printNode(child, depth + 1);
            });
        }
    }
}

class ManualNode {

    _manual;
    _parentNode;

    //expose variables
    id;
    name;
    children = [];

    constructor(manual) {
        this._manual = manual;
        this.id = manual.id;
        this.name = manual.name;
    }

    setParentNode(parentNode) {
        this._parentNode = parentNode;
    }

    deleted() {
        return this.manual.deleteYn === "Y"
    }

    isRootNode() {
        return this.manual.parentId === undefined || this.manual.parentId == null || this.manual.parentId === 0;
    }

    hasParentNode() {
        return !!this._parentNode;
    }

    hasChildrenNode() {
        return this.children.length > 0;
    }

    addChildNode(manualNode) {
        this.children.push(manualNode);
        manualNode.setParentNode(this);
    }

    get isNode() {
        return this.manual.type === "NODE";
    }

    get isBook() {
        return this.manual.type === "BOOK";
    }

    get isNew() {
        return this.manual.status === "NEW";
    }

    get isActive() {
        return this.manual.status === "ACTIVE";
    }

    get isClosed() {
        return this.manual.status === "CLOSED";
    }

    get itemText() {
        return this.manual.name + "," + this.manual.title;
    }

    get manual() {
        return this._manual;
    }

    get parentId() {
        return this.manual.parentId;
    }

    get canonicalName() {
        let cname = this.name;
        if (this.hasParentNode()) {
            cname = this._parentNode.canonicalName + '__' + cname;
        }
        return cname;
    }

}

export {ManualTree, ManualNode}
